<template>
	<div>
		<v-card class="mb-4">
			<v-card-title class="pt-1">
				<div class="d-flex align-center justify-space-between flex-1">
					<p class="font-weight-bold body-2 px-1 mb-0">Agenda - Visita Técnica</p>
					<div v-if="isClientUser">
						<v-btn
							v-if="activeSchedule && activeSchedule.status == 1"
							depressed
							color="success"
							block
							x-small
							:loading="loading"
							@click="startConfirmUserSchedule()"
						>
							<v-icon small>mdi-check</v-icon>
							<p class="mb-0 ml-2 caption">Confirmar Visita Técnica</p>
						</v-btn>
					</div>
					<div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									color="#524D4D"
									@click="editCrmSchedule"
									:disabled="!canEditInfo"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-calendar-plus-outline</v-icon>
								</v-btn>
							</template>
							<span>Agendar Nueva Visita Técnica</span>
						</v-tooltip>
					</div>
				</div>
			</v-card-title>
			<v-card-text class="pb-2">
				<div class="dbflex justify-end align-center" v-if="!isClientUser">
					<div v-if="conversation.schedules && conversation.schedules.length" style="width: 100%;min-width:220px;">
						<v-select
							v-model="selectedScheduleId"
							:items="conversation.schedules"
							item-value="id"
							:menu-props="{ top: true, offsetY: true }"
							label="Visitas Técnicas"
							class="custom-height-search custom-height-calendar"
							outlined
							dense
							hide-details
						>
							<template v-slot:item="data">
								<v-list-item-content>
									<v-list-item-title>
										<div class="d-flex align-center justify-space-between">
											<div class="mr-2">{{ data.item.vt_date | toDateTime }}</div>
											<div class="grey--text text--darken-1">{{ data.item.user_schedule?.title || 'Sin título' }}</div>
										</div>
									</v-list-item-title>
								</v-list-item-content>
							</template>
							<template v-slot:selection="data">
								<div class="d-flex align-center justify-space-between" style="min-width: 100%;">
									<p class="mb-0 caption flex-1">{{ data.item.vt_date | toDateTime }}</p>
									<p class="mb-0 font-weight-bold caption">{{ data.item.user_schedule?.title || 'Sin título' }}</p>
								</div>
							</template>
						</v-select>
					</div>
				</div>
				<v-divider class="my-2"></v-divider>
				<div class="pb-2" v-if="activeSchedule">
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="editScheduleTitle">
						<v-text-field
							v-model="newScheduleTitle"
							label="Nuevo Título Agenda"
							placeholder="Ingrese el título"
							outlined
							required
							dense
							hide-details=""
							maxlength="255"
							class="custom-height-search custom-height-calendar my-2"
						>
							<template v-slot:append-outer>
								<v-btn
									icon
									color="error"
									@click="editScheduleTitle = false"
									:disabled="!canEditInfo"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
								<v-btn
									icon
									color="warning"
									@click="sendEditScheduleTitle"
									:disabled="!canEditInfo"
								>
									<v-icon>mdi-check</v-icon>
								</v-btn>
							</template>
						</v-text-field>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Título Agenda</div><span>:</span> <b class="text-end" style="flex: 1;">{{activeSchedule.user_schedule?.title}}</b></div>
						<div class="action-container">
							<v-btn
								icon
								color="warning"
								x-small
								@click="startEditTitle"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-pencil-outline</v-icon>
							</v-btn>
						</div>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Fecha agendada</div><span>:</span> <b class="text-end" style="flex: 1;">{{activeSchedule.vt_date | toDateTime}} hrs.</b></div>
						<div class="action-container"></div>
					</div>
					<div class="d-flex justify-space-between align-center" v-if="editAddress">
						<v-autocomplete
							v-model="newAddress.address"
							:items="itemsAddress"
							name="address"
							:search-input.sync="search"
							prepend-inner-icon="mdi-map-marker"
							label="Dirección"
							placeholder="Dirección"
							autocomplete="off"
							outlined
							dense
							hide-details
							:cache-items="cachingItems"
							:loading="loadingAddress"
							:filter="d => d"
							color="secondary"
							item-color="secondary"
							return-object
							@change="change"
						></v-autocomplete>
						<v-btn
							icon
							small
							color="error"
							@click="editAddress = false"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{conversation.project_info?.address?.address}}</b></div>
						<div class="action-container">
							<v-btn
								icon
								color="warning"
								x-small
								@click="startEditAddress"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-vector-square-edit</v-icon>
							</v-btn>
						</div>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!isClientUser">
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Tipo de Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{conversation.project_info?.project_type.name}}</b></div>
						<div class="action-container">
							<ProjectTypeSelectorMenu
								:isDisabled="!canEditInfo"
								:onClick="(project_type) => { changeProjectType(project_type.id) }"/>
						</div>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!isClientUser">
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Zona Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{conversation.project_info?.zone?.name}}</b></div>
						<v-menu v-model="zoneMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
							<template v-slot:activator="{ on, attrs }">
								<div class="action-container">
									<v-btn
										icon
										color="warning"
										x-small
										:disabled="!canEditInfo"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</div>
							</template>
							<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
								<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
									<p class="caption mb-0 font-weight-bold white--text">Cambiar Zona Proyecto</p>
								</v-list-item>
								<v-list-item-group color="#524D4D">
									<v-list-item
										v-for="(zone, index) in zones"
										:key="index"
										dense
										@click="changeIptZone(zone.id)"
									>
										<v-list-item-title dense>
											{{ zone.name }}
										</v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-menu>
					</div>
					<div class="d-flex justify-space-between align-center" style="gap: 5px;" v-if="editCrmContractValue">
						<v-text-field
							v-model="newContractValueCrm"
							label="Nuevo Valor Contrato"
							placeholder="Ingrese el valor"
							outlined
							required
							dense
							hide-details=""
							maxlength="9"
							class="custom-height-search custom-height-calendar my-2"
							@keypress="isNumberKey"
						>
						</v-text-field>
						<div style="width: 100%;max-width: 220px;">
							<v-select
								:value="newContractValueCrmTax"
								:items="taxOptions"
								:loading="$store.state.general.loadingTaxesOptions"
								:menu-props="{ top: true, offsetY: true }"
								item-text="name"
								item-value="id"
								label="Tipo Impuesto"
								class="custom-height-search custom-height-calendar flex-grow-0"
								outlined
								dense
								required
								return-object
								@change="changeContractValueTaxSelection"
							>
								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title>
											<div class="d-flex align-center justify-space-between">
												<div class="d-flex align-center justify-space-between flex-1">
													<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
													<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
												</div>
											</div>
										</v-list-item-title>
									</v-list-item-content>
								</template>
								<template v-slot:selection="data">
									<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
										<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
										<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
									</div>
								</template>
							</v-select>
						</div>
						<v-btn
							icon
							color="error"
							@click="editCrmContractValue = false"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
						<v-btn
							icon
							color="warning"
							@click="sendEditContractValue"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-check</v-icon>
						</v-btn>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else-if="!isClientUser && conversation.project_info?.contract_info?.contract_value">
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Valor Contrato</div><span>:</span> <b class="text-end" style="flex: 1;">${{conversation.project_info?.contract_info?.contract_value | toThousandFilter}}</b> <span v-if="conversation.project_info?.contract_info?.contract_value > 0 && conversation.project_info?.contract_info?.tax_value?.value">+</span> <span v-if="conversation.project_info?.contract_info?.contract_value > 0">{{conversation.project_info?.contract_info?.tax_value?.name}}</span></div>
						<div class="action-container">
							<v-btn
								icon
								color="warning"
								x-small
								@click="startEditContractValue"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-pencil-outline</v-icon>
							</v-btn>
						</div>
					</div>
					<v-divider class="my-3"></v-divider>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Usuario Encargado</div><span>:</span> <b class="text-end" style="flex: 1;">{{scheduledUserName}}</b></div>
						<div class="action-container">
							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										color="warning"
										x-small
										:disabled="!canEditInfo"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(responsible, index) in $store.state.users.usersList"
											:key="index"
											dense
											@click="changeUserAssignation(responsible.id)"
										>
											<v-list-item-title dense>
												<div class="d-flex align-center">
													<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
													<div>
														<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
														<p class="mb-0 caption">{{ responsible.email }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
					<!-- <v-select
						v-if="$checkPermissions(['schedule_assignment'])"
						v-model="scheduledUserId"
						:items="$store.state.users.usersList"
						:loading="loadingUsers"
						item-text="profile.name"
						item-value="id"
						label="Usuario encargado"
						outlined
						dense
						required
						hide-details
						:rules="requiredRule"
						@change="changeUserAssignation"
					>
						<template v-slot:item="data">
							<v-list-item-content>
								<div class="d-flex align-center">
									<img :src="data?.item?.profile?.avatar" class="user-avatar mr-2" v-if="data?.item?.profile?.avatar"/>
									<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
									<div>
										<p class="mb-0 caption">{{ data?.item?.profile?.name }} {{ data?.item?.profile?.lastname }} {{ data?.item?.profile?.second_lastname }}</p>
										<p class="mb-0 caption">{{ data?.item?.email }}</p>
									</div>
								</div>
							</v-list-item-content>
						</template>
						<template #append-outer>
							<v-btn
								class="my-0"
								icon
								@click="addUser"
							>
								<v-icon>mdi-account-plus</v-icon>
							</v-btn>
						</template>
					</v-select>
					<p v-else class="d-flex justify-space-between mb-1">Usuario Encargado: <b>{{scheduledUserName}}</b></p> -->
					<v-divider class="my-3"></v-divider>
					<div v-if="!isClientUser">
						<p class="d-flex justify-space-between align-center mb-1">
							Estado Visita Técnica:
							<v-chip
								v-if="activeSchedule"
								class="mt-1"
								:color="vtStatusColor"
								label
								outlined
								small
							>
								{{vtStatusText}}
							</v-chip>
							<v-chip
								v-else
								class="mt-1"
								color="danger"
								label
								dark
								outlined
								small
							>
								<v-icon small class="mr-2">mdi-close</v-icon>
								No se generó agenda
							</v-chip>
						</p>
						<p class="d-flex justify-space-between align-center mb-1"
							v-if="activeSchedule && activeSchedule.payments && activeSchedule.payments.length > 0">Fecha de Pago Visita Técnica: <b>{{ activeSchedule.payments[0].payment_info?.created_at | toDateTime }}</b></p>
						<v-divider class="my-2"></v-divider>
						<div>
							<p class="mb-1" style="font-size: 12px;line-height: 14px;">Modifica el valor de la visita técnica. Se enviará automáticamente una notificación y un correo al usuario para que confirme.</p>
							<div class="d-flex justify-space-between align-center" style="gap: 5px;" v-if="editValue">
								<v-text-field
									v-model="newValueCrm"
									label="Nuevo Valor visita técnica"
									placeholder="Ingrese el valor"
									outlined
									required
									dense
									hide-details=""
									maxlength="9"
									class="custom-height-search custom-height-calendar my-2"
									@keypress="isNumberKey"
								>
								</v-text-field>
								<div style="width: 100%;max-width: 220px;">
									<v-select
										:value="newValueCrmTax"
										:items="taxOptions"
										:loading="$store.state.general.loadingTaxesOptions"
										:menu-props="{ top: true, offsetY: true }"
										item-text="name"
										item-value="id"
										label="Tipo Impuesto"
										class="custom-height-search custom-height-calendar flex-grow-0"
										outlined
										dense
										required
										return-object
										@change="changeCrmValueTaxSelection"
									>
										<template v-slot:item="data">
											<v-list-item-content>
												<v-list-item-title>
													<div class="d-flex align-center justify-space-between">
														<div class="d-flex align-center justify-space-between flex-1">
															<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
															<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
														</div>
													</div>
												</v-list-item-title>
											</v-list-item-content>
										</template>
										<template v-slot:selection="data">
											<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
												<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
												<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
											</div>
										</template>
									</v-select>
								</div>
								<v-btn
									icon
									color="error"
									@click="editValue = false"
									:disabled="!canEditInfo"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
								<v-btn
									icon
									color="warning"
									@click="sendEditValue"
									:disabled="!canEditInfo"
								>
									<v-icon>mdi-check</v-icon>
								</v-btn>
							</div>
							<div class="d-flex justify-space-between align-center mb-1 pr-1 item-background-hover" v-else>
								<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Valor Visita Técnica</div><span>:</span> <b class="text-end" style="flex: 1;">${{conversation.project_info?.address_value | toThousandFilter}}</b> <span v-if="conversation.project_info?.tax_value?.value">+</span> <span v-if="conversation.project_info?.address_value > 0">{{conversation.project_info?.tax_value?.name}}</span></div>
								<div class="action-container">
									<v-btn
										icon
										color="warning"
										x-small
										@click="startEditValue"
										:disabled="!canEditInfo"
									>
										<v-icon>mdi-pencil-outline</v-icon>
									</v-btn>
								</div>
							</div>
						</div>
						<v-divider class="my-2"></v-divider>
						<div class="d-flex justify-space-between align-center mb-2">
							<p class="font-weight-bold mb-0">Cierres Visita Técnica</p>
							<v-chip
								class="mt-1"
								label
								outlined
								small
								@click="startCloseAgenda"
								:disabled="!canEditInfo"
							>
								<v-icon small class="mr-2">mdi-calendar-alert-outline</v-icon>
								Agregar Cierre Visita
							</v-chip>
						</div>
						<div class="px-2" v-if="activeSchedule && activeSchedule.closure && activeSchedule.closure.length > 0">
							<div class="d-flex px-1">
								<p class="py-1 mb-0 d-flex flex-1 caption font-weight-bold w-100" style="width: 100%">
									Fecha de realización
								</p>
								<v-divider class="mx-1" vertical></v-divider>
								<p class="py-1 mb-0 d-flex flex-1 caption font-weight-bold w-100" style="width: 100%">
									Comentario
								</p>
							</div>
							<v-divider></v-divider>
							<div class="py-0 d-flex px-1 item-background-hover" v-for="(closure,index) in activeSchedule.closure" :key="index">
								<p class="py-1 mb-0 d-flex flex-1 caption" style="width: 100%">
									<v-icon small class="mr-2">mdi-calendar</v-icon>
									{{closure.closed}}
								</p>
								<v-divider class="mx-1" vertical></v-divider>
								<p class="py-1 mb-0 d-flex flex-1 caption" style="width: 100%">
									{{closure.closure_report}}
								</p>
							</div>
						</div>
						<v-divider class="my-2"></v-divider>
						<p class="d-flex justify-space-between align-center mb-1">
							Estado Informe:
							<v-chip
								class="mt-1"
								:color="vtStatus.color"
								small
								label
								dark
								v-if="vtStatus"
							>
								<v-icon class="mr-1" x-small>mdi-email-outline</v-icon>
								{{vtStatus.text}}
							</v-chip>
						</p>
					</div>
					<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
						<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Valor Visita Técnica</div><span>:</span> <b class="text-end" style="flex: 1;">${{conversation.project_info?.address_value | toThousandFilter}}</b> <span v-if="conversation.project_info?.tax_value?.value">+</span> <span v-if="conversation.project_info?.address_value > 0">{{conversation.project_info?.tax_value?.name}}</span></div>
						<div class="action-container">
						</div>
					</div>
					<v-divider class="my-3"></v-divider>
					<div v-if="isClientUser">
						<v-btn
							v-if="activeSchedule && activeSchedule.status == 1"
							depressed
							color="success"
							block
							small
							class="mt-3"
							:loading="loading"
							@click="startConfirmUserSchedule()"
						>
							<v-icon small>mdi-check</v-icon>
							<p class="mb-0 ml-2 caption">Confirmar Visita Técnica</p>
						</v-btn>
					</div>
					<div v-else>
						<v-btn
							depressed
							color="#524D4D"
							:dark="!((sentEmailDiff != -1 && sentEmailDiff < 24) || !(activeSchedule && activeSchedule.status == 1)) && editPermission"
							block
							small
							class="mt-3"
							:disabled="((sentEmailDiff != -1 && sentEmailDiff < 24) || !(activeSchedule && activeSchedule.status == 1)) && editPermission"
							:loading="loading"
							@click="resendPaymentRequest()"
						>
							<v-icon small>mdi-email-outline</v-icon>
							<p class="mb-0 ml-2 caption">Reenviar Solicitud de Pago</p>
						</v-btn>
						<v-btn
							depressed
							color="#524D4D"
							:dark="activeSchedule && activeSchedule.status == 1 && editPermission"
							block
							small
							class="mt-3"
							:loading="loading"
							:disabled="!(activeSchedule && activeSchedule.status == 1) || !canEditInfo"
							@click="confirmScheduleManual()"
						>
							<v-icon small>mdi-email-outline</v-icon>
							<p class="mb-0 ml-2 caption">Confirmar Visita Técnica (Transferencia)</p>
						</v-btn>
					</div>
					<div class="py-0 px-1 d-flex align-center justify-space-between"
						v-if="activeSchedule && activeSchedule.payments && activeSchedule.payments.length > 0">
						<div>
							<v-icon class="mr-2" small>mdi-email-outline</v-icon>
							{{ activeSchedule.payments[0].payment_info?.created_at | toDateTime }}
						</div>
						<v-chip
							class="ma-2"
							color="success"
							small
							dark
						>
							Fecha de Pago Visita Técnica
						</v-chip>
					</div>
				</div>
				<div class="pa-2" v-else>
					No se agendó visita técnica
				</div>
			</v-card-text>
		</v-card>
		<v-card class="mb-4" max-height="400" style="overflow-y: auto;" v-if="vtAddress">
			<v-card-title class="sticky-title py-1">
				<div class="d-flex align-center justify-space-between flex-1">
					<p class="font-weight-bold body-2 px-1 mb-0">Ubicación Visita Técnica</p>
				</div>
			</v-card-title>
			<v-card-text class="py-2">
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 150px">Dirección VT</div><span>:</span> <b class="text-end" style="flex: 1;">{{vtAddress.address}}</b></div>
					<div class="action-container">
					</div>
				</div>
				<GmapMap
					v-if="vtAddress"
					:center="vtAddress.cords"
					:zoom="mapZoom"
					@zoom_changed="updateZoom"
					ref="vtMap"
					style="width: 100%; height: 300px"
					class="mt-2"
				>
					<GmapMarker
						:position="vtAddress.cords"
						@mousedown="startZoomIn"
						@mouseup="stopZoomIn"
						:icon="{url: require('@/assets/marker_schedule.png'), scaledSize: { width: 45, height: 47 }}"
					/>
				</GmapMap>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import moment from 'moment'
import { gmapApi } from 'vue2-google-maps'
import {sendScheduleEmail, confirmUserSchedule} from '@/helpers/api/conversations'
import {editCrmValue, assignScheduleToUser, editCrmProjectType, editCrmZoneIpt, editContractValue} from '@/helpers/api/crm'
import {confirmSchedule, updateScheduleAddress, updateUserSchedule} from '@/helpers/api/schedule'
import ProjectTypeSelectorMenu from '@/components/Helpers/Components/ProjectTypeSelectorMenu'

export default {
	components: {ProjectTypeSelectorMenu},
  data() {
    return {
			search: '',
			mapZoom: 7,
			zoneMenu: false,
      zoomInterval: null,
      isZooming: false,
			itemsAddress: [],
			loadingAddress: false,
			loading: false,
			editScheduleTitle: false,
			newScheduleTitle: null,
			editAddress: false,
			newAddress: {address: null, coordinates: null},
			cachingItems: false,
			scheduledUserId: null,
			changingScheduleUser: false,
			editValue: false,
			editCrmContractValue: false,
			newValueCrm: null,
			newValueCrmTax: null,
			newContractValueCrm: null,
			newContractValueCrmTax: null,
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
				selectedScheduleId: null,
		}
	},
  computed: {
		google: gmapApi,
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		limitedView(){
			return this.isClientUser()
		},
		isClientUser(){
			return this.conversation?.client?.id == this.$store.state.user.userInfo.id
		},
		canEditInfo(){
			// Puede editar sólo si tiene permiso y si no hay un contrato firmado en la línea de proyectos
			return this.editPermission && !this.conversation?.pl_signed_contract
		},
		scheduledUserName(){
			if(this.activeSchedule && this.activeSchedule?.user_schedule && this.activeSchedule?.user_schedule?.responsible){
				const user = this.activeSchedule?.user_schedule?.responsible
				return user.profile.name + ' ' + user.profile.lastname + ' ' + user.profile.second_lastname
			}
			return '--'
		},
		editPermission(){
			return this.$checkPermissions(['edit_crm']) || this.scheduledUserId == this.$store.state.user.userInfo.id
		},
		zones(){
			return this.$store.state.projects.zoneIpt
		},
    conversation() {
      return this.$store.state.crm.conversation
    },
		activeSchedule(){
			if(this.selectedScheduleId && this.conversation?.schedules){
				const found = this.conversation.schedules.find(s => s.id == this.selectedScheduleId)
				if(found) return found
			}
			return this.conversation.schedule
		},
		loadingUsers(){
			return this.$store.state.users.loadingUserList || this.changingScheduleUser
		},
		vtStatusText(){
			const s = this.activeSchedule
			if(!s) return 'Sin agenda'
			if((!s?.closure || s.closure.length === 0) && moment().diff(moment(s.vt_date), 'hours') >= 24) {
				return 'No Realizada'
			}
			else if(s.closure && s.closure.length > 0){
				return 'Realizada'
			}
			else if(s.status == 1){
				return 'Esperando confirmación / Pago'
			}
			return 'Confirmada Por Cliente / En espera de visita'
		},
		vtStatusColor(){
			const s = this.activeSchedule
			if(!s) return 'grey'
			if((!s?.closure || s.closure.length === 0) && moment().diff(moment(s.vt_date), 'hours') >= 24) {
				return '#FF120B'
			}
			else if(s.closure && s.closure.length > 0){
				return 'green'
			}
			else if(s.status == 1){
				return 'orange'
			}
			return 'orange'
		},
		vtStatus(){
			const s = this.activeSchedule
			if(s && s.status == 2 && s.request_email && s.request_email.length > 0){
				return {
					text: 'Informe Enviado',
					color: 'success'
				}
			}
			else if(s){
				return {
					text: 'Informe Pendiente',
					color: 'warning'
				}
			}
			return null
		},
		geoAddress(){
			if(this.conversation && this.conversation.project_info && this.conversation.project_info?.coordinates){
				return {lat: this.conversation.project_info?.coordinates.coordinates[1], lng: this.conversation.project_info?.coordinates.coordinates[0]}
			}
			return null
		},
		vtAddress() {
			if(!this.activeSchedule){
				return null
			}
			const addressData = this.activeSchedule?.user_schedule?.address;

			if (!addressData || typeof addressData !== 'object') {
				return { address: '', cords: { lat: null, lng: null } };
			}

			const coords = addressData?.coordinates?.coordinates || [];
			return {
				address: addressData?.address || '',
				cords: {
					lat: coords[1] || null,
					lng: coords[0] || null
				}
			};
		},
		sentEmailDiff(){
			const s = this.activeSchedule
			if(s && s.request_email && s.request_email.length > 0){
				const current = moment()
				const startTime = s.request_email[0].created_at
				var duration = moment.duration(current.diff(startTime))
				var hours = duration.asHours()
				return hours
			}
			else if(s && s.request_email && s.request_email.length == 0){
				return -1
			}
			return null
		},
		userData(){
			if(this.conversation && this.conversation.user && this.conversation.user.user){
				const user = {
					...this.conversation.user,
					...this.conversation.user.user.profile
				}
				return user
			}
			return this.conversation.user
		}
	},
	watch: {
    conversation(newValue) {
			if(newValue && newValue.user){
				this.selectedScheduleId = newValue.schedule?.id || (newValue.schedules && newValue.schedules.length ? newValue.schedules[0].id : null)
				this.scheduledUserId = (newValue.schedule || newValue.schedules && newValue.schedules.length ? (newValue.schedule?.user_schedule?.user_id || (newValue.schedules[0]?.user_schedule?.user_id)) : null)
				this.$nextTick(() => {
					this.$gmapApiPromiseLazy().then(() => {
						this.autocompleteService = new this.google.maps.places.AutocompleteService()
					})
				});
			}
    },
    search(newSearch) {
			this.cachingItems = false
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.itemsAddress = []; // Limpiar los resultados si no hay búsqueda
      }
    },
	},
	mounted(){
		if(this.conversation && this.conversation.user){
			this.$store.dispatch('projects/getAllZoneIpts')
			this.selectedScheduleId = this.conversation.schedule?.id || (this.conversation.schedules && this.conversation.schedules.length ? this.conversation.schedules[0].id : null)
			this.scheduledUserId = this.activeSchedule?.user_schedule?.user_id
			this.$nextTick(() => {
				this.$gmapApiPromiseLazy().then(() => {
					this.autocompleteService = new this.google.maps.places.AutocompleteService()
				})
			});
		}
	},
	beforeDestroy() {
		this.$store.commit('schedule/setNewScheduleModal', false)
		this.$store.commit('schedule/setNewScheduleEditing', null)
		},
	methods: {
		changeCrmValueTaxSelection(tax){
			this.newValueCrmTax = tax.id
		},
		changeContractValueTaxSelection(tax){
			this.newContractValueCrmTax = tax.id
		},
		async startConfirmUserSchedule(){
			if(this.activeSchedule?.schedule_id && !this.conversation?.project_info?.address_value){
				this.confirmScheduleUser()
			}
			else{
				const url = 'https://apiarq.insomnia.cl/schedule-confirm?s=' + this.activeSchedule?.id
				window.open(url, '_blank').focus();
			}
		},
		async confirmScheduleUser(){
			const confirmation = await confirmUserSchedule({schedule_id: this.activeSchedule?.schedule_id})
			if(confirmation.code == 200){
				this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
				const messageData = {
					message: 'Se ha confirmado la Visita Técnica',
					title: 'Visita Técnica Confirmada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
		editCrmSchedule(){
			let address = null
			let coordinates = null
			if(this.activeSchedule && !this.activeSchedule?.closure?.length){
				const data = {
					message: 'Para crear una nueva Visita Técnica debes cerrar la que se encuentra en curso.',
					title: 'Visita Técnica Activa',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-exclamation',
					color: 'orange'
				}
				this.$store.dispatch('general/addMessage', data)
				return
			}
			if(this.conversation.project_info && this.conversation.project_info?.address?.address){
				address = this.conversation.project_info?.address?.address
				coordinates = this.conversation.project_info?.coordinates
			}
			this.$store.commit('schedule/setNewScheduleEditing', {
				title: 'Visita Técnica',
				user_name: this.userData.name,
				user_email: this.userData.email,
				user_phone: this.userData.phone,
				lastname: this.userData.lastname,
				second_lastname: this.userData.second_lastname,
				crm_id: this.conversation.id,
				vt_polygon: this.conversation.vt_polygon,
				address: {address, coordinates},
				to_crm: true
			})
			this.$store.commit('schedule/setNewScheduleModal', true)
		},
		async changeUserAssignation(new_user_id){
			this.changingScheduleUser = true
			await assignScheduleToUser({new_user_id, schedule_id: this.activeSchedule.user_schedule.id})
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
			this.changingScheduleUser = false
		},
		startEditTitle(){
			this.editScheduleTitle = !this.editScheduleTitle
			this.newScheduleTitle = this.activeSchedule.user_schedule?.title
		},
		async sendEditScheduleTitle(){
			await updateUserSchedule({schedule_id: this.activeSchedule.user_schedule.id, title: this.newScheduleTitle})
			this.editScheduleTitle = false
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
		startEditAddress(){
			this.cachingItems = true
			this.editAddress = !this.editAddress
			let address = this.conversation.project_info?.address?.address ?? ''
			if(this.conversation.project_info?.project_district && this.conversation.project_info?.project_district.length > 1){
				address += ' ' + this.conversation.project_info?.project_district
			}
			this.itemsAddress = [{text: address.toUpperCase(), value: address.toUpperCase()}]
			this.newAddress.address = address.toUpperCase()
		},
    startZoomIn() {
      this.isZooming = true;
      this.zoomIn();
    },
    stopZoomIn() {
      this.isZooming = false;
      if (this.zoomInterval) {
        clearInterval(this.zoomInterval);
        this.zoomInterval = null;
      }
    },
    zoomIn() {
      if (this.zoomInterval) {
        clearInterval(this.zoomInterval);
      }

      this.zoomInterval = setInterval(() => {
        if (this.isZooming && this.mapZoom < 20) {
          this.mapZoom += 1;
					
					const map = this.$refs.vtMap.$mapObject;
					if (map) {
						map.setCenter(this.geoAddress); // El mapa se vuelve a centrar en el mismo punto
					}
        } else {
          clearInterval(this.zoomInterval);
          this.zoomInterval = null;
        }
      }, 100);
    },
    updateZoom(zoom) {
      this.mapZoom = zoom;
    },
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.itemsAddress = predictions.filter(p => p.place_id).map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.itemsAddress = []; // Limpiar los resultados en caso de error
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.newAddress.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
						this.updateAddress(this.newAddress)
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
    change(value) {
			if(value && value.value && value.value.place_id){
				this.newAddress.address = value.text;
				this.getPlaceDetails(value.value.place_id)
			}
			else{
				this.newAddress.address = value.text || value;
				this.updateAddress(this.newAddress)
			}
    },
		async updateAddress(newAddress){
			this.editAddress = false
			const data = {
				...{schedule_id: this.activeSchedule.id},
				...newAddress
			}
			await updateScheduleAddress(data)
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
    addUser() {
			this.$store.commit('users/setNewUserModalEditing', null)
			this.$store.commit('users/setNewUserModal', true)
    },
		startEditValue(){
			this.newValueCrm = this.conversation.project_info?.address_value
			this.newValueCrmTax = this.conversation.project_info?.address_value_tax_id
			this.editValue = !this.editValue
		},
		async sendEditValue(){
			await editCrmValue({conversation_id: this.conversation.id, new_value: this.newValueCrm, new_value_tax: this.newValueCrmTax, simple_agenda_id: this.selectedScheduleId})
			this.editValue = false
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
		startEditContractValue(){
			this.newContractValueCrm = this.conversation.project_info?.contract_info?.contract_value
			this.newContractValueCrmTax = this.conversation.project_info?.contract_info?.contract_value_tax_id
			this.editCrmContractValue = !this.editCrmContractValue
		},
		async sendEditContractValue(){
			await editContractValue({conversation_id: this.conversation.id, contract_value: this.newContractValueCrm, contract_value_tax_id: this.newContractValueCrmTax})
			this.editCrmContractValue = false
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
		async changeProjectType(project_type_id){
			await editCrmProjectType({conversation_id: this.conversation.id, project_type_id})
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
		async changeIptZone(zone_id){
			this.zoneMenu = false
			await editCrmZoneIpt({conversation_id: this.conversation.id, zone_id})
			this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
		},
		startCloseAgenda(){
			if(this.activeSchedule){
				this.$store.commit('vt/setAgendaClosureModal', this.activeSchedule.id)
			}
		},
		async resendPaymentRequest(){
			if(!this.conversation.project_info?.address_value || this.conversation.project_info?.address_value == 0){
				const data = {
					message: 'Por favor asigna un valor a la visita técnica antes de enviar el correo.',
					title: 'Visita sin valor',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-exclamation',
					color: 'orange'
				}
				this.$store.dispatch('general/addMessage', data)
				return null
			}
			this.loading = true
			const schedule_payment = await sendScheduleEmail({schedule_id: this.activeSchedule.id})
			if(schedule_payment.code == 200){
				const data = {
					message: 'El correo con la solicitud de pago ha sido enviado al usuario.',
					title: 'Correo enviado correctamente',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
			}
			else{
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al enviar el correo',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
			this.loading = false
		},
		async confirmScheduleManual(){
			if(!this.conversation.project_info?.address_value || this.conversation.project_info?.address_value == 0){
				const data = {
					message: 'Por favor asigna un valor a la visita técnica antes de enviar el correo.',
					title: 'Visita sin valor',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-exclamation',
					color: 'orange'
				}
				this.$store.dispatch('general/addMessage', data)
				return null
			}
			this.loading = true
			const schedule_payment = await confirmSchedule({schedule_id: this.activeSchedule.id, payment_method: 'Transferencia'})
			if(schedule_payment.code == 200){
				const data = {
					message: 'Se ha confirmado la visita técnica.',
					title: 'Agenda Confirmada',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.$store.dispatch('crm/getConversation', {conversation_id: this.conversation.id})
			}
			else{
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al confirmar',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
			this.loading = false
		}
	}
}
</script>
<style scoped>
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.sticky-title {
		position: sticky;
		top: 0;
		background: white;
		z-index: 2;
		border-bottom: 1px solid #eee;
	}
</style>